/* Tab Navigation and Tab Panels */
// for use with %tabNavPage extensions in base.scss
// (tabNavPage includes page styling for %tabNavList and %cardList)
const tabs = function(documentElem) {
  function tabsInit(launchModal) {
    // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/Tab_Role#example

    activateTabs(documentElem);
    activatePanelCards(documentElem, launchModal);
  }

  function activateTabs(documentElem) {
    const tabList = documentElem.querySelector('[role="tablist"]:not([data-tablist-active=false])');
    const tabs = (tabList) ? tabList.querySelectorAll('[role="tab"]') : null;
    if (!tabs) return;

    // Add a click event handler to each tab
    tabs.forEach(tab => {
      tab.addEventListener("click", changeTabs);
      // remove href link since javascript works:
      tab.removeAttribute("href");
    });

    // Select first tab and make it active:
    const firstTab = tabList.querySelector('[role="tab"]');
    firstTab.setAttribute("aria-selected", true);
    changeTabs(firstTab);

    navKeyListen(tabList, tabs, changeTabs);
  }

  function activatePanelCards(documentElem, launchModal) {
    // add js classes to tabpanels and cards
    const tabPanels = documentElem.querySelectorAll('[role="tabpanel"] > ul');
    tabPanels.forEach(panel => {
      panel.className += " js";
      const cards = Array.from(panel.children);
      cards.forEach(card => {
        card.setAttribute("tabindex", 0);
        card.addEventListener("click", launchModal);
      });
      navKeyListen(panel, cards);
    });
  }

  function navKeyListen(list, elems) {
    // Enable arrow navigation between elements in the list
    let elemFocus = 0;

    list.addEventListener("keydown", e => {
      if (e.keyCode === 13) { // enter
        e.preventDefault();
        clickCard(e);
      }
      // Move right
      if (e.keyCode === 39 || e.keyCode === 37) {
        elems[elemFocus].setAttribute("tabindex", -1);
        if (e.keyCode === 39) {
          elemFocus++;
          // If we're at the end, go to the start
          if (elemFocus >= elems.length) {
            elemFocus = 0;
          }
          // Move left
        } else if (e.keyCode === 37) {
          elemFocus--;
          // If we're at the start, move to the end
          if (elemFocus < 0) {
            elemFocus = elems.length - 1;
          }
        }

        elems[elemFocus].setAttribute("tabindex", 0);
        elems[elemFocus].focus();
      }
    });
  }

  function clickCard(e) { e.target.click(e); }

  function changeTabs(e) {
    const target = e.target || e;
    const parent = target.parentNode;
    const grandparent = parent.parentNode;

    // Remove all current selected tabs
    grandparent
      .querySelectorAll('[aria-selected="true"]')
      .forEach(t => t.setAttribute("aria-selected", false));

    // Set this tab as selected
    target.setAttribute("aria-selected", true);

    // Hide all tab panels
    documentElem
      .querySelectorAll('[role="tabpanel"]')
      .forEach(p => p.setAttribute("hidden", true));

    // Show the selected panel
    grandparent.parentNode
      .querySelector(`#${target.getAttribute("aria-controls")}`)
      .removeAttribute("hidden");
  }

  return {
    init: tabsInit
  }
}
